import { OrderedMap } from 'immutable';
import pick from 'lodash.pick';

import {
  OWNER_PARAM_MAP,
  DEVICE_GROUP_MAP,
  FILTER_KEYS,
} from '../../common/filters/constants';

export const FILTERS_INFO = Object.freeze({
  [FILTER_KEYS.OWNER]: Object.freeze({
    name: 'Owner',
    inputType: 'radio',
    search: true,
  }),
  [FILTER_KEYS.BUILD]: Object.freeze({
    name: 'Build',
  }),
  [FILTER_KEYS.OS]: Object.freeze({
    name: 'OS',
  }),
  [FILTER_KEYS.DEVICE]: Object.freeze({
    name: 'Device',
  }),
  [FILTER_KEYS.FRAMEWORK]: Object.freeze({
    name: 'Framework',
  }),
  [FILTER_KEYS.TAG]: Object.freeze({
    name: 'Tag',
    search: true,
  }),
  [FILTER_KEYS.DEVICE_GROUP]: Object.freeze({
    name: 'Device Group',
    inputType: 'radio',
  }),
});

/**
 * Houses common RDC filters, excluding deviceGroup, for displaying the filters across RDC pages.
 */
export const COMMON_FILTERS_MAP = OrderedMap(
  pick(FILTERS_INFO, [
    FILTER_KEYS.OWNER,
    FILTER_KEYS.BUILD,
    FILTER_KEYS.OS,
    FILTER_KEYS.DEVICE,
    FILTER_KEYS.DEVICE_GROUP,
    FILTER_KEYS.FRAMEWORK,
    FILTER_KEYS.TAG,
  ]),
);

export const FILTERS_MAP = OrderedMap(
  pick(FILTERS_INFO, [
    FILTER_KEYS.OWNER,
    FILTER_KEYS.BUILD,
    FILTER_KEYS.OS,
    FILTER_KEYS.DEVICE,
    FILTER_KEYS.TAG,
    FILTER_KEYS.DEVICE_GROUP,
    FILTER_KEYS.FRAMEWORK,
  ]),
);

export const RDC_COVERAGE_FILTERS_MAP = OrderedMap(
  pick(FILTERS_INFO, [FILTER_KEYS.OWNER, FILTER_KEYS.DEVICE_GROUP]),
);

export { OWNER_PARAM_MAP, DEVICE_GROUP_MAP };
